import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getUsers, getActiveTab } from 'selectors/admin/team/contractor-team';
import {
  loadUserFormRequest,
  setCurrentUserId,
  setShowInviteUserModal,
} from 'actions/admin/team/contractor-team';
import SimpleTable from 'components/shared/table/SimpleTable';
import UserStatus from 'components/shared/text/UserStatus';
import { formatPhoneNumber } from 'services/utils/text-util';
import { CONTRACTOR_ROLES, TYPES } from 'services/utils/users-util';
import { UserModalState } from 'components/shared/modal/InviteUserModal';
import './ContractorTeam.css';
import { usersApi } from 'services/api/users-api';
import { getCurrentUser } from 'selectors/authentication';

const UsersTableHeaders = [
  'NAME',
  'TITLE',
  'STATUS',
  'WORK ORDERS',
  'PHONE NUMBER',
  'EMAIL',
  'ACTIONS',
];

class UsersTable extends Component {
  render() {
    const { users } = this.props;
    return (
      <SimpleTable
        headers={UsersTableHeaders}
        rows={this.mapUsers(users)}
        emptyMessage={'No Users'}
      />
    );
  }

  handleSelectUser = (user) => {
    this.props.dispatch(setCurrentUserId(user.id));
    this.props.dispatch(loadUserFormRequest(user));
    this.props.dispatch(setShowInviteUserModal(true, UserModalState.READ_ONLY));
  };

  handleResendInvite = (id) => {
    usersApi.resendInvite(id);
  };

  actionBtns(currentUser, user) {
    return (
      <div className="action-btns-wrapper">
        <span
          className="linkable action-btn"
          onClick={() => this.handleSelectUser(user)}
        >
          Edit
        </span>
        {usersApi.resendInviteLink(currentUser, user) ? (
          <span
            className="linkable action-btn"
            onClick={() => this.handleResendInvite(user.id)}
          >
            Resend Invite
          </span>
        ) : (
          ''
        )}
      </div>
    );
  }

  mapUsers(users) {
    const { currentUser } = this.props;

    return users.map((user) => {
      let status;
      if (
        user.invitation_sent_at === null ||
        user.invitation_accepted_at !== null
      ) {
        status = user.status;
      } else if (user.invitation_accepted_at === null) {
        status = 'pending_invitation';
      }

      return [
        <span className="h4">{`${user.first_name} ${user.last_name}`}</span>,
        user.roles && this.mapTitle(user.roles),
        status && <UserStatus status={status} />,
        user.work_order_users_count,
        user.phone_number !== null
          ? formatPhoneNumber(user.phone_number)
          : 'N/A',
        <a href={`mailto:${user.email}`} className="mailto">
          {user.email}
        </a>,
        this.actionBtns(currentUser, user),
      ];
    });
  }

  mapTitle(roles) {
    const titles = roles
      .filter((role) => role.resource_type === TYPES.CONTRACTOR)
      .map((role) => {
        return CONTRACTOR_ROLES[role.name];
      });

    if (titles.length > 1) {
      return titles.join(' / ');
    } else if (titles.length === 1) {
      return titles[0];
    } else {
      return 'N/A';
    }
  }
}

export default connect((state) => {
  return {
    users: getUsers(state),
    activeTab: getActiveTab(state),
    currentUser: getCurrentUser(state),
  };
})(UsersTable);



// WEBPACK FOOTER //
// ./src/components/admin/team/UsersTable.js